/* eslint-disable */
import dcmConf from './dcm.json';
import predictitConf from './predictit.json';


const DEFAULT_CONF = 'predictit';
const translations = {
  dcm: dcmConf,
  [DEFAULT_CONF]: predictitConf,
};


export const $txt = (message) => {
  const project = process.env.PROJECT;
  return translations[project][message] || translations[DEFAULT_CONF][message];
};



// WEBPACK FOOTER //
// ./src/mixins/staticConf/utils.js